<template>
  <div
    class="sc-message--data"
    v-html="messageText"
  />
</template>

<script>
import Autolinker from 'autolinker'
// @TODO: FIX IE11 const fmt = require('msgdown')
export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    messageText () {
      // @TODO: const escaped = this.escape(this.data.text)
      const escaped = this.data.text
      // @TODO: FIX IE11 return Autolinker.link(this.messageStyling ? fmt(escaped) : escaped, {
      return Autolinker.link(escaped, {
        urls: { schemeMatches: true, wwwMatches: true, tldMatches: false },
        className: 'chatLink',
        truncate: { length: 50, location: 'smart' }
      })
    }
  },
  methods: {
    escape (input) {
      return input.replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
    }
  }
}
</script>

<style scoped>

</style>
